module.exports = __webpack_public_path__ + "media/images/mstile-150x150-e71d07d2a77851ec0c7fd2c78935c60b.png";